import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Habilidad } from 'src/app/interfaces/habilidad';
import { Response } from 'src/app/interfaces/response';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HabilidadService {

  private baseApiUrl = environment.baseApi + '/privado/habilidad';

  constructor(private httpClient: HttpClient) { }

  async obtenerHabilidadesPorIdCandidato(idCandidato: number){
    return await this.httpClient.get<Response>(`${this.baseApiUrl}/${idCandidato}`).toPromise();
  }

  registrarHabilidad(idCandidato:number, body: Habilidad): Observable<Response> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.post<Response>(`${this.baseApiUrl}/${idCandidato}`, body, { headers });
  }

  actualizarHabilidad(body: Habilidad): Observable<Response> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.put<Response>(`${this.baseApiUrl}`, body, { headers });
  }

  eliminarHabilidadPorId(idCandidato: number, idHabilidad: number): Observable<Response> {
    return this.httpClient.delete<Response>(`${this.baseApiUrl}/${idCandidato}/${idHabilidad}`);
  }
}
